// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicTextWithInfo-module__root-eZnlax","rootmedium":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicTextWithInfo-module__rootmedium-OO8ij_","icon":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicTextWithInfo-module__icon-yo_Rbh","iconmedium":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicTextWithInfo-module__iconmedium-H0P6s5"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicTextWithInfo-module__root-eZnlax\",\"rootmedium\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicTextWithInfo-module__rootmedium-OO8ij_\",\"icon\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicTextWithInfo-module__icon-yo_Rbh\",\"iconmedium\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicTextWithInfo-module__iconmedium-H0P6s5\"}";
        // 1793541990588
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  